import {
	Component, ViewEncapsulation, HostListener,
	OnInit, Inject, OnDestroy, DoCheck, ChangeDetectorRef,
	trigger, style, transition, state, animate, NgZone
} from '@angular/core';
import { Router, NavigationStart, NavigationError, NavigationEnd, NavigationCancel, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
// Prototypes
import './Prototypes/p-string';
// Interfaaces
import { IComponent } from './share/interfaces';
// services
import * as srv from './share/services';

import * as jquery from 'jquery';
declare var $: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements IComponent, OnInit {

	// Implement IComponent
	name = 'AppComponent';
	subscriptions: Subscription[] = [];

	// implement local variables
	// *

	/**
	 *
	 */
	constructor(
		private _router: Router,
		private _loaderSrv: srv.LoaderService,
		private _logSrv: srv.LogService
	) {


	}
	ngOnInit() {
		this.subscriptions.push(
			this._router.events.subscribe(s => {

				if (s instanceof NavigationError) {
					//this._logSrv.Debug(this.name, ['app NavigationError', s]);
					this._loaderSrv.SetLoading(this.name, false);
					// if (s.url === s.url.toLowerCase()) {
					//   this._router.navigate(['/error']);
					// }
					// if (s.url !== s.url.toLowerCase()) {
					//   let red = s.url.toLowerCase();
					//   this._router.navigate([red]);
					// }
				}

				if (s instanceof NavigationStart) {
					//this._logSrv.Debug(this.name, ['app NavigationStart', s]);
					this._loaderSrv.SetLoading(this.name, true);
				}
				if (s instanceof NavigationEnd) {
					//this._logSrv.Debug(this.name, ['app NavigationEnd', s.url, s]);
					this._loaderSrv.SetLoading(this.name, false);
				}
				if (s instanceof NavigationCancel) {
					//this._logSrv.Debug(this.name, ['app NavigationCancel', s]);
					this._loaderSrv.SetLoading(this.name, false);
				}
			})
		);
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/app.component.ts